import LocalStorageUtils from '@/utils/localStorageUtils'
import LogRocket from 'logrocket'
import * as Sentry from '@sentry/browser'
import Package from '~/package.json'

function identify ({ username, email, oneSignalUserUuid } = {})
{
    const fields =
    {
        clientVersion: Package.version,
        appBundleId: LocalStorageUtils.cityManifest.appBundleId,
        userId: LocalStorageUtils.userUuid,
        deviceUuid: device.uuid
    }
    if (username) fields.username = username
    if (email) fields.email = email
    if (oneSignalUserUuid) fields.oneSignalUserUuid = oneSignalUserUuid

    LogRocket.identify(LocalStorageUtils.userUuid, fields)
    LogRocket.getSessionURL(sessionURL =>
    {
        Sentry.configureScope(scope =>
        {
            scope.setUser(fields)
            console.log('Attaching LogRocket to Sentry')
            scope.setExtra('sessionURL', sessionURL)
        })
    })
}

export default { identify }


// WEBPACK FOOTER //
// ./src/utils/identifyUtils.js